import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UsuarioListarModule } from './usuario-listar/usuario-listar.module'; 
import { UsuarioInserirModule } from './usuario-inserir/usuario-inserir.module';
import { UsuarioEditarModule } from './usuario-editar/usuario-editar.module';
import { UsuarioDetalharModule } from './usuario-detalhar/usuario-detalhar.module';
import { UsuarioDashBoardModule } from './usuario-dashboard/usuario-dashboard.module';


@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => UsuarioListarModule },
        { path: 'inserir', data: { breadcrumb : 'Inserir' }, loadChildren: () => UsuarioInserirModule },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => UsuarioEditarModule },        
        { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => UsuarioDetalharModule },
        { path: 'dashboard', data: { breadcrumb : 'Dashboard' }, loadChildren: () => UsuarioDashBoardModule },        



    
    ])],
    exports: [RouterModule]
})
export class UsuarioAppRoutingModule { }